export default "__VITE_ASSET__BNunILI9__$_?url__"